import React from 'react'
import { Field, useField } from "formik"
import './FormikCheckbox.scss'
import { downloadDocument, getStyles } from "src/helpers"
import { Link } from "react-router"

interface IFormikCheckbox {
    name: string
    readonly: boolean
}

const FormikCheckbox: React.FC<IFormikCheckbox> = (props) => {
    const { name, readonly } = props

    const [field, meta,] = useField(name)

    const styles = getStyles("checkbox", [{
        decision: Boolean(meta.touched && meta.error),
        name: "required"
    }])

    return (
        <label className={styles}>
            <Field
                name={name}
                readonly={readonly}
                type={"checkbox"}
                className={"checkbox__field"}
            />
            <picture className={"checkbox__picture"}>
                {field.value ?
                    <>
                        <source
                            srcSet={"/misc/checked-desktop.png"}
                            media="(min-width: 1280px)"
                        />
                        <img
                            src="/misc/checked-mobile.png"
                            alt=""
                        />
                    </>
                    :
                    <>
                        <source
                            srcSet={"/misc/non-checked-desktop.png"}
                            media="(min-width: 1280px)"
                        />
                        <img
                            src="/misc/non-checked-desktop.png"
                            alt=""
                        />
                    </>
                }
            </picture>
            <span className={"paragraph paragraph--1"}>Соглашаюсь на
                {" "}<Link
                    to={"https://docs.google.com/document/d/1Ch4QQpnqYOAFxuL2SUBLFbl2s06UrI3w/edit?usp=sharing&ouid=110964201333730186297&rtpof=true&sd=true"}
                    target={'_blank'}
                    className={"paragraph--underlined"}
                    // onClick={() => downloadDocument()}
                >
                    обработку персональных данных
                </Link>
            </span>
        </label>
    )
}

export default FormikCheckbox